export default function addMenuEventListener() {
    const menu = document.querySelector('.nav__menu');
    menu.addEventListener('click', shouldToggleSubMenu);
}

function shouldToggleSubMenu(ev) {
    if (ev.target.nodeName.toUpperCase() === 'A') {
        ev.target.blur();
        if (toggleSubmenu(ev.target)) {
            ev.preventDefault();
            ev.stopPropagation();
            addClickOutsideMenuListener();
        }
    }
}

function toggleSubmenu(link) {
    const submenu = getSubmenuFor(link);
    console.log(submenu);
    if (submenu) {
        toggleSubmenuClass(submenu);
        return true;
    }

    return false;
}

function toggleSubmenuClass(submenu) {
    return submenu.classList.toggle(getSubmenuVisibleClass());
}

function getSubmenuFor(link) {
    const container = link.parentNode;
    return container.querySelector('.sub-menu');
}

function addClickOutsideMenuListener() {
    document.addEventListener('click', clickOutsideListener);
}

function removeClickOutsideListener() {
    document.removeEventListener('click', clickOutsideListener);
}

function clickOutsideListener(ev) {
    if (!clickedOnSubmenu(ev.target)) {
        ev.preventDefault();
        toggleSubmenuClass(getOpenSubmenu());
        removeClickOutsideListener();
    }
}

function clickedOnSubmenu(clickTarget) {
    let loopElement = clickTarget;
    while (!loopElement.classList.contains(getSubmenuVisibleClass())) {
        if (hasDomParentNode(loopElement)) {
            loopElement = loopElement.parentNode;
        } else {
            return false;
        }
    }

    return true;
}

function hasDomParentNode(element) {
    return typeof element.parentNode.classList !== 'undefined'
}

function getOpenSubmenu() {
    return document.querySelector(`.${getSubmenuVisibleClass()}`);
}

function getSubmenuVisibleClass() {
    return 'sub-menu--visible';
}


// WEBPACK FOOTER //
// ./wp-content/themes/template/js/src/Modules/Menu.js